import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import colors from "../../../../../Constants/colors";
import { monthNavigatorContainer } from "./UsageStyle";

const MonthNavigator = ({ date, setDate, minDate, maxDate }) => {
  const normalizeDate = (date) =>
    new Date(date?.getFullYear(), date?.getMonth(), 1);

  const currentDate = normalizeDate(date);
  const normalizedMinDate = normalizeDate(minDate);
  const normalizedMaxDate = normalizeDate(maxDate);

  const isNextDisabled = currentDate >= normalizedMaxDate;
  const isPreviousDisabled = currentDate <= normalizedMinDate;

  const handlePreviousMonth = () => {
    const newDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    if (!isPreviousDisabled) {
      setDate(newDate);
    }
  };

  const handleNextMonth = () => {
    const newDate = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    if (!isNextDisabled) {
      setDate(newDate);
    }
  };

  return (
    <Box sx={monthNavigatorContainer}>
      <Button onClick={handlePreviousMonth} disabled={isPreviousDisabled}>
        <ArrowBackIos />
      </Button>
      <Typography
        variant="body1"
        sx={{
          fontSize: "16px",
          color: colors.white,
          width: "80px",
          textAlign: "center",
        }}
      >
        {date.toLocaleString("default", { month: "long" })}
      </Typography>
      <Button
        onClick={handleNextMonth}
        sx={{ color: colors.white }}
        disabled={isNextDisabled}
      >
        <ArrowForwardIos />
      </Button>
    </Box>
  );
};

export default MonthNavigator;
